import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import { showProfileDriverEmailModal, hideProfileDriverEmailModal } from '../../store/profile/action';
import { useDispatch, useSelector } from 'react-redux';
import { Chip } from '@material-ui/core';
import { getCheckoutSelectPhoneState } from '../../../store/buyPermits/selector';
import { getCheckoutSelectPhoneStates, hideCheckoutSelectPhoneModal, setCheckoutSelectedPhone } from '../../../store/buyPermits/action';



const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,       
  },
  btnConfirm: {
    paddingLeft: 8,
    paddingRight: 8,
    borderRadius:10,
    height:23,
  },
  btnRow: {
    textAlign: 'right',
    marginTop: 20,
  },
}));

const emailData=[{
  "id": 112,
  "defaultFlag": true,
  "line1": "H6",
  "line2": "156",
  "city": "Noida",
  "state": {
      "code": "AK"
  },
  "zip": "22341",
  "inactive": false
},{
"id": 113,
"defaultFlag": false,
"line1": "Lucknow",
"line2": "156",
"city": "Noida",
"state": {
    "code": "AK"
},
"zip": "22341",
"inactive": true
},{
  "id": 114,
  "defaultFlag": false,
  "line1": "Kanpur",
  "line2": "156",
  "city": "Noida",
  "state": {
      "code": "AK"
  },
  "zip": "22341",
  "inactive": false
  }];

export default function SelectPhoneModalForm(props) {
  const classes = useStyles();
  
  const dispatch=useDispatch();
  const getCheckoutSelectPhoneStateData = useSelector((state) => state?.exitOrderReducer?.checkoutSelectPhoneState);
  const [MyPhoneData, setMyPhoneData] = useState(Array.isArray(getCheckoutSelectPhoneStateData) && getCheckoutSelectPhoneStateData)
 

  const {CloseSelectPhoneModal,handleOpenAddPhoneModal}=props;

  useEffect(() => {
    const ActiveData = Array.isArray(getCheckoutSelectPhoneStateData) && getCheckoutSelectPhoneStateData.filter((items) => {
      return items.inactive === false
    })
    setMyPhoneData(ActiveData)
  }, [getCheckoutSelectPhoneStateData])

  

  // const MyCheckboxFunc = (MyCheckVal) => {
  //   if (MyCheckVal === true) {
  //     const InActiveData = emailData.filter((items) => {
  //       return items.inactive === true
  //     })
  //     setMyPhoneData([...MyPhoneData, ...InActiveData])
  //   }
  //   else {
  //     setMyPhoneData(emailData.filter((items) => {
  //       return items.inactive === false
  //     }))
  //   }
  // }

  const [selectedPhone,setSelectedPhone]=useState([]);
  const [selectedIndex, setSelectedIndex] = React.useState(1);


  const handleOpenCheckoutPhoneModal = (ele,e)=>{
    setSelectedPhone(ele);  
    setSelectedIndex(ele.id);
  }

  const SetCheckoutPhone = (ele)=>{
    dispatch(setCheckoutSelectedPhone(selectedPhone));
    dispatch(hideCheckoutSelectPhoneModal());
  }  
 
  if(MyPhoneData && MyPhoneData.length>0) {
    return (
      <>
        <List className={classes.root}>
            {MyPhoneData.map((ele)=>{
              if(ele.defaultFlag===true){
                return(
                  <>
                    <ListItem key={ele.id} 
                     onClick={(e)=>handleOpenCheckoutPhoneModal(ele,e)}
                     //style={bgColor}  
                     selected={selectedIndex === ele.id}                
                    >
                      <ListItemText primary={ele.number}/>
                      {ele.defaultFlag===true?<Chip label="Default"/>:''}
                    </ListItem>
                    <Divider /> 
                  </>   
                )
              }
            })}
            {MyPhoneData.map((ele)=>{
                if(ele.defaultFlag===false){
                  return(
                      <>
                      <ListItem key={ele.id} 
                        onClick={(e)=>handleOpenCheckoutPhoneModal(ele,e)}
                       // style={bgColor}
                       selected={selectedIndex === ele.id}
                      >
                        <ListItemText primary={ele.number}/>
                        {ele.defaultFlag===true?<Chip label="Default"/>:''}
                      </ListItem>
                      <Divider /> 
                      </>   
                  )
                }
            })}                                            
        </List>   
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.btnRow} >
            <Button color="primary" variant="text"
              onClick={handleOpenAddPhoneModal}
             >Add Phone</Button>
            <Button onClick={CloseSelectPhoneModal}>Cancel</Button>
            <Button onClick={SetCheckoutPhone} variant="contained" type={'submit'} color="primary" className={classes.btnConfirm}>
              Confirm
            </Button>
          </Grid>
        </Grid>     
      </>
    );
  } else {
    return (
      <>
        <List className={classes.root}>
          <ListItem>
            <div>Phone not Found</div>
          </ListItem>
        </List>       
        {/* <Checkbox MyCheckboxFunc={MyCheckboxFunc} PhoneCheck="PhoneCheck" title={"Show Inactive Phone"} /> */}
      
      </>
    );
  }
}





